import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, {useContext, useState} from 'react'
import { EditedContext } from '../../../../partials/Context'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import {descriptions_content} from '../partials/Descriptions'
import Phone from './Phone';
import Options from './Options';
import Services from './Services';
import getCookie from '../../../../partials/cookie';
import { Errors } from '../../../../partials/Partials';

function Notifications({errors}) {
    const {lawyer_data, setLawyerData, setErrors, getCurrentLawyer} = useContext(EditedContext);
    const {phone_sms, receive_emails, receive_sms, notification} = lawyer_data || '';
    const {receive_orders} = notification || ''
    
    const [descriptions, setDescriptions] = useState([false, false, false])

    let list = []

    const displayDescription = (index) => {
        let tempArr = [...descriptions]
        tempArr[index] = !tempArr[index]
        setDescriptions(tempArr)
    }

    descriptions_content.forEach((description, index) => {
        const {title, content, type} = description || ''
        list.push(
            <div className="option" key={index}>
                <input type="checkbox" id="" name="" value="" checked={type === 'receive_sms' ? receive_sms : receive_emails} onClick={() => changeOption(type)}/>
                <label  onClick={() => {
                    displayDescription(index)
                }}>{title}</label>&emsp;
                {descriptions[index] ?
                <>
                    <FontAwesomeIcon className="chevron" icon={faChevronRight} style={{ transform: 'rotate(90deg)'}} onClick={() => displayDescription(index)}/>
                    {content}
                </>
                
                :
                <FontAwesomeIcon className="chevron" icon={faChevronRight} onClick={() => displayDescription(index)}/>
                }
                
            </div>
        )
    })

    const changeOption = (option) => {
        let current_value = (option === 'receive_sms') ? receive_sms : (option === 'receive_emails') ? receive_emails : receive_orders;
        let if_notification = ''
        if (option === 'receive_orders') {
            if_notification = 'notification/'
        }
        
        const csrftoken = getCookie('csrftoken')
        fetch(`/api/lawyer_profiles_extended/current/${if_notification}`, {
            method:'PATCH',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": csrftoken
            },
            body: JSON.stringify({
                [option]: !current_value
            })
        }).then(
            res => {
                if (res.ok) {
                    setErrors([])
                    getCurrentLawyer(setLawyerData, setErrors)
                } else {
                    setErrors(['Nie udało się zmienić ustawień powiadomień'])
                }
            }
        )
    }
    
  return (
    <div id="notifications" className="section">
        <Errors errors={errors}/>
        <h3 className="title">Powiadomienia</h3>
        <Phone phone_sms={phone_sms}/>
        <Options list={list} receive_sms={receive_sms} receive_emails={receive_emails} changeOption={changeOption}/>
        <Services notification={notification} changeOption={changeOption}/>
    </div>
  )
}

export default Notifications